var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckupIconBl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.166016,
    width: 20.0008,
    height: 20,
    rx: 10,
    fill: "#EEF1F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16602 6L6.16602 6.66667M6.16602 6.66667L4.16602 12.6667C5.3477 13.5556 6.98512 13.5556 8.16681 12.6667M6.16602 6.66667L8.16605 12.6667M6.16602 6.66667L10.166 5.33333M14.166 6.66667L16.166 6M14.166 6.66667L12.166 12.6667C13.3477 13.5556 14.9851 13.5556 16.1668 12.6667M14.166 6.66667L16.1661 12.6667M14.166 6.66667L10.166 5.33333M10.166 4V5.33333M10.166 16V5.33333M10.166 16H8.16602M10.166 16H12.166",
    stroke: "#3C5DB7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckupIconBl);
export default __webpack_public_path__ + "static/media/checkupIconBl.6549cea8a419a417836432213c26b0f0.svg";
export { ForwardRef as ReactComponent };